import React from 'react';
import {
  ReferenceMaterialResponse,
} from '@/components/admin/SlideReferenceMaterialsDropdown/SlideReferenceMaterialsDropdown.utils';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import { shared_program_reference_material_path } from '@/modules/routes';
import Tooltip from '@/components/common/Tooltip';
import { ConditionalWrap } from '@/components/common/Utils';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import calendarPlusIcon from 'images/icons/calendar-plus.svg';
import calendarCheckedIcon from 'images/icons/calendar-checked.svg';
import * as Routes from '@/modules/routes';

interface ReferenceMaterialCardProps {
  modalManager: ModalManager,
  referenceMaterial: ReferenceMaterialResponse;
  setAssignmentModalValues: (any) => void;
}

const ReferenceMaterialCard = ({
  modalManager,
  referenceMaterial,
  setAssignmentModalValues,
}: ReferenceMaterialCardProps) => {
  const programId = useSlideShowContext(state => state.programId);
  const lessonId = useSlideShowContext(state => state.lessonId);
  const userType = useSlideShowContext(state => state.userType);
  const isStaffer = userType !== 'Student';
  const isSysadmin = userType === 'Sysadmin';
  const assignIcon = referenceMaterial.is_assigned ? calendarCheckedIcon : calendarPlusIcon;

  const path = shared_program_reference_material_path(
    programId,
    referenceMaterial.id,
    { tag: referenceMaterial.tag_values },
  );

  const tooltipContent = () => (
    <div>
      An assignment has been created for this content.
      <a href={Routes.teacher_program_assignments_path(programId, { lesson_id: lessonId })}> View Details</a>
    </div>
  );

  const onAssignmentButtonClick = () => {
    if (referenceMaterial.is_assigned) return;

    setAssignmentModalValues({
      modelType: referenceMaterial.assignable_type,
      modelsToAssign: [{
        label: referenceMaterial.title,
        score: referenceMaterial.max_score,
        value: `ReferenceMaterial-${referenceMaterial.id}`,
      }],
    });
    modalManager.open();
  };

  return (
    <div
      className={cn(
        'tw-flex tw-items-center tw-rounded tw-shadow tw-py-2 tw-px-3',
        'tw-gap-2 tw-border tw-border-solid tw-border-med-grey',
      )}
    >
      <div className={cn('tw-bg-teal-blue tw-rounded tw-inline-block')}>
        <Icon fill="#fff" icon="Reading" />
      </div>
      <a
        className="tw-p-0 !tw-text-tci-purple !tw-no-underline hover:!tw-underline !tw-font-normal"
        href={path}
        rel="noopener noreferrer"
        target="_blank"
      >
        {referenceMaterial.title}
      </a>
      {isStaffer && (
        <ConditionalWrap
          condition={referenceMaterial.is_assigned}
          wrap={children => (
            <Tooltip content={tooltipContent()}>
              {children}
            </Tooltip>
          )}
        >
          <button
            className="tw-bg-transparent tw-border-none focus:tw-border-none active:tw-border-none tw-cursor-pointer
              focus:tw-outline-none tw-ml-auto"
            disabled={isSysadmin}
            type="button"
            onClick={onAssignmentButtonClick}
          >
            <img
              alt="Create assignment"
              height={16}
              src={assignIcon}
              width={16}
            />
          </button>
        </ConditionalWrap>
      )}
    </div>
  );
};

export default ReferenceMaterialCard;
